import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React from 'react';
import { Radio, Select } from 'udesk-ui';
import TaskRuleGather from 'Component/pages/components/task-rule-gather';
import NotMatchAnyRule from './components/NotMatchAnyRule';

const Template = (props) => {
    const locales = UdeskLocales['current'];

    const {
        title,
        assignModelValue,
        onAssignModelValueChange,
        disabled,
        assignConfList,
        onAssignConfListChange,
        fields,
        users,
        taskId,
        taskName,
        inspectDataSource,
        notMatchValue,
        onNotMatchValueChange,
        notMatchSelectValue,
        onNotMatchSelectValueChange,
        getUserListUrl,
        filterOption,
        showSpecify,
        secondLevelInspectors,
        onSecondLevelInspectorsChange,
    } = props;

    return (
        <>
            <div className="automatic-content-item-body-item">
                <div className="automatic-content-item-body-item-title automatic-content-item-body-item-title-screening-condition">
                    {title}
                </div>

                <div className="automatic-content-item-body-item-content">
                    <Radio.Group
                        value={assignModelValue}
                        disabled={disabled}
                        onChange={onAssignModelValueChange}
                    >
                        {Udesk.enums.distributeTypes
                            .filter((e) =>
                                showSpecify ? true : e.id !== Udesk.enums.distributeTypes.specify.id
                            )
                            .map((item) => {
                                return (
                                    <Radio key={item.id} value={item.id}>
                                        {item.name}
                                    </Radio>
                                );
                            })}
                    </Radio.Group>
                </div>
            </div>

            {assignModelValue === Udesk.enums.distributeTypes.rule.id ? (
                <>
                    <div className="automatic-content-item-body-item">
                        <div className="automatic-content-item-body-item-content automatic-content-item-body-item-content-allocation">
                            <TaskRuleGather
                                rules={assignConfList}
                                fields={fields}
                                onChanged={onAssignConfListChange}
                                users={users}
                                taskId={taskId}
                                taskName={taskName}
                                type={inspectDataSource}
                                disabled={disabled}
                            />
                        </div>
                    </div>

                    <div className="automatic-content-item-body-item">
                        <NotMatchAnyRule
                            title={
                                locales.pages.tasks.manage.template.automaticAdd.index
                                    .notMatchAnyRule
                            }
                            radioValue={notMatchValue}
                            disabled={disabled}
                            onRadioChange={onNotMatchValueChange}
                            selectValue={notMatchSelectValue}
                            onSelectChange={onNotMatchSelectValueChange}
                            getUserListUrl={getUserListUrl}
                            filterOption={filterOption}
                        />
                    </div>
                </>
            ) : assignModelValue === Udesk.enums.distributeTypes.specify.id ? (
                <div className="automatic-content-item-body-item">
                    <Select
                        showSearch
                        optionFilterProp="label"
                        options={users.map((user) => ({
                            value: user.id,
                            label: user.realname,
                        }))}
                        style={{ width: 250 }}
                        value={secondLevelInspectors}
                        onChange={onSecondLevelInspectorsChange}
                    />
                </div>
            ) : null}
        </>
    );
};

export default Template;
